import { Theme, makeStyles } from "@material-ui/core";

export const useStyles = makeStyles((theme: Theme) => ({
  title: {
    fontWeight: 500,
    fontFamily: "Lato",
    marginRight: "10px",
    fontSize: theme.typography.pxToRem(20),
  },
  subtitle: {
    color: "#747F9D",
    fontWeight: 400,
    fontFamily: "Lato",
    fontSize: theme.typography.pxToRem(16),
  },
  divider: {
    display: "flex",
    justifyContent: "center",
    width: "100%",
    margin: "20px 0",
  },
  expandedIcon: {
    transform: "rotate(180deg)",
  },
  contractedIcon: {
    transform: "rotate(0deg)",
  },
}));
